import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  upgradeSubscription,
  ActivePlanList,
} from "../../redux/services/SubscriptionServices/Subscription.Services";
import { errorToast, successToast } from "../../Utils/toast";
import { closeModal } from "../../redux/features/modalSlice";

function UpgradeSubscription({ data: subscription, onSuccess }) {
  const dispatch = useDispatch();

  console.log("subscription data in upgrade:", subscription); // debug

  const [loading, setLoading] = useState(false);
  const [planLoading, setPlanLoading] = useState(false);
  const [planList, setPlanList] = useState([]);

  const [form, setForm] = useState({
    new_plan_id: "",
    payment_amount: subscription?.price || "",
    payment_method: "cash",
    payment_id: "",
  });

  const fetchPlans = async () => {
    try {
      setPlanLoading(true);
      const res = await ActivePlanList({ page: 1, per_page: 100 });
      const list = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res)
        ? res
        : [];
      setPlanList(list);
    } catch (error) {
      console.log(error);
      errorToast("Failed to load plans");
      setPlanList([]);
    } finally {
      setPlanLoading(false);
    }
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "new_plan_id") {
      const selectedPlan = planList.find(
        (p) => String(p.id) === String(value)
      );
      setForm((prev) => ({
        ...prev,
        new_plan_id: value,
        payment_amount: selectedPlan?.price ?? prev.payment_amount,
      }));
      return;
    }
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!subscription?.id) {
      return errorToast("Subscription ID missing. Please reload the page.");
    }
    if (!form.new_plan_id) return errorToast("Please select a new plan");
    if (!form.payment_amount) return errorToast("Please enter payment amount");

    try {
      setLoading(true);
      const payload = {
        subscription_id: subscription.id,
        new_plan_id: Number(form.new_plan_id),
        payment_amount: Number(form.payment_amount),
        payment_method: form.payment_method,
        payment_id: form.payment_id,
      };

      const res = await upgradeSubscription(payload);
      successToast(res?.message || "Subscription upgraded successfully");

      dispatch(closeModal());
      onSuccess?.();
    } catch (error) {
      console.log(error);
      errorToast(
        error?.response?.data?.message || "Failed to upgrade subscription"
      );
    } finally {
      setLoading(false);
    }
  };

  const selectedPlan = planList.find(
    (p) => String(p.id) === String(form.new_plan_id)
  );

  return (
    <div>
      {subscription ? (
        <div className="alert alert-info mb-4">
          <div>
            <strong>Vendor:</strong>{" "}
            {subscription?.vendor?.name ||
              subscription?.vendor?.mobile ||
              subscription?.user_id ||
              "-"}
          </div>
          <div>
            <strong>Current Plan:</strong> {subscription?.name || "-"}
          </div>
          <div>
            <strong>Price:</strong>{" "}
            {subscription?.price ? `₹${subscription.price}` : "-"}
          </div>
        </div>
      ) : (
        <div className="alert alert-danger mb-4">
          Subscription data not available.
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Select New Plan *</label>
            <select
              className="form-control"
              name="new_plan_id"
              value={form.new_plan_id}
              onChange={handleChange}
              disabled={planLoading}
            >
              <option value="">
                {planLoading ? "Loading plans..." : "-- Select Plan --"}
              </option>
              {planList.map((plan) => (
                <option key={plan.id} value={plan.id}>
                  {plan.name}
                  {plan.price ? ` — ₹${plan.price}` : ""}
                  {plan.duration_days ? ` (${plan.duration_days} days)` : ""}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Payment Amount *</label>
            <input
              type="number"
              className="form-control"
              name="payment_amount"
              value={form.payment_amount}
              onChange={handleChange}
              placeholder="Enter amount"
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Payment Method</label>
            <select
              className="form-control"
              name="payment_method"
              value={form.payment_method}
              onChange={handleChange}
            >
              <option value="cash">Cash</option>
              <option value="online">Online</option>
              <option value="upi">UPI</option>
              <option value="card">Card</option>
            </select>
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Payment ID</label>
            <input
              type="text"
              className="form-control"
              name="payment_id"
              value={form.payment_id}
              onChange={handleChange}
              placeholder="e.g. MANUAL_003"
            />
          </div>
        </div>
        {selectedPlan && (
          <div className="alert alert-secondary mb-3">
            <div className="fw-bold text-primary mb-1">Selected Plan</div>
            <div className="fw-bold">{selectedPlan.name}</div>
            {selectedPlan.description && (
              <div className="text-muted" style={{ fontSize: "13px" }}>
                {selectedPlan.description}
              </div>
            )}
            <div className="mt-2 d-flex gap-3 flex-wrap" style={{ fontSize: "13px" }}>
              {selectedPlan.duration_days && (
                <span>
                  <strong>Duration:</strong> {selectedPlan.duration_days} days
                </span>
              )}
              {selectedPlan.price != null && (
                <span>
                  <strong>Price:</strong> ₹{selectedPlan.price}
                </span>
              )}
            </div>
          </div>
        )}

        <div className="d-flex gap-2 mt-3">
          <button
            type="submit"
            className="add-btn"
            disabled={loading || planLoading}
          >
            {loading ? "Upgrading..." : "Upgrade Plan"}
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => dispatch(closeModal())}
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default UpgradeSubscription;